<template>
    <Promised :pending-delay="null" :promise="getTenantDisplayLabelPromise(tenant)" v-if="tenant != null">
        <template v-slot:pending> Loading... </template>
        <template v-slot="tenantDisplayLabel">
            {{ tenantDisplayLabel }}
        </template>
    </Promised>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { Promised } from "@/lib/Promised";
import { useMainStore } from "@/mainStore";
export default defineComponent({
    props: {
        tenant: String,
    },
    setup() {
        const getTenantDisplayLabelPromise = async (tenant: string) => {
            return await useMainStore().getTenantDisplayLabel([tenant])[tenant];
        };

        return { getTenantDisplayLabelPromise };
    },
    components: {
        Promised,
    },
});
</script>
